import { withInstall } from '../../../../utils/with-install'
import HeatMap from './HeatMap.vue'

export const ElAmapLayerHeatMap = withInstall(HeatMap)
export default ElAmapLayerHeatMap
